import { useState, useEffect } from "react";
import axios from "axios";
import { getCommonParam } from "../config";

const getLanguages = async () => {
  try {
    const apiCommonParam = getCommonParam();
    const { apiUrl, axiosConfig, companyId } = apiCommonParam;
    const endpoint = `azienda/lingue/${companyId}`;
    const { data: languages } = await axios.get(`${apiUrl}${endpoint}`, axiosConfig);
    return languages.substr(-1) === "," ? languages.substr(0, languages.length - 1) : languages;
  } catch (error) {
    console.error(error);
  }
};

export const useLanguages = () => {
  const [languages, setLanguages] = useState();
  useEffect(() => {
    getLanguages().then((res) => setLanguages(res));
  }, []);

  return { languages, setLanguages };
};
